import { useState, useEffect } from 'react';

const KEY_MAP = {
  DOWN: 40,
  ENTER: 13,
  LEFT: 37,
  RIGHT: 39,
  UP: 38,
};

const useKeyboardControls = ({
  options = [],
  enterCallback,
  defaultKeyUpCallback,
  keyUpCallback,
  resetIndex = true,
  defaultIndex = -1,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(defaultIndex);
  useEffect(() => {
    setSelectedIndex(defaultIndex);
  }, [defaultIndex, options]);
  return [
    selectedIndex,
    {
      onKeyUp: (e) => {
        switch (e.which) {
          case KEY_MAP.RIGHT:
          case KEY_MAP.DOWN: {
            if (selectedIndex + 1 < options.length) {
              setSelectedIndex((i) => i + 1);
              if (keyUpCallback) {
                keyUpCallback(options, selectedIndex + 1);
              }
            }
            break;
          }
          case KEY_MAP.LEFT:
          case KEY_MAP.UP: {
            if (selectedIndex > defaultIndex) {
              setSelectedIndex((i) => i - 1);
              if (keyUpCallback) {
                keyUpCallback(options, selectedIndex - 1);
              }
            }
            break;
          }
          case KEY_MAP.ENTER: {
            e.preventDefault();
            if (selectedIndex > defaultIndex && selectedIndex < options.length) {
              if (resetIndex) {
                setSelectedIndex(defaultIndex);
              }
              if (enterCallback) {
                enterCallback(options, selectedIndex);
              }
            }
            break;
          }
          default: {
            if (defaultKeyUpCallback) {
              defaultKeyUpCallback();
            }
            break;
          }
        }
      },
    },
  ];
};

export default useKeyboardControls;
